import type { Starter } from '../Starter'

// Replacement queue (verticals #6/#7 decision): class/ERD seeds via the
// software-design profiles replace these once renderers are verified —
// a PR-B follow-up, tracked in the invariants test's debt allowlist.
export const softwareStarters: Starter[] = [
  {
    id: 'uml-class',
    name: 'UML Class',
    description: 'Class structure',
    thumbnailUrl: '/assets/images/thumbnails/tb_classdiagram.svg',
    translationKey: 'templates.names.umlClass',
    artifact: { kind: 'legacy', templateId: 'QntZ3BLMuEE', legacyType: 'diagram/def/uml-class.js#UMLClass' },
    job: ['design-system'],
    function: ['software'],
    curatedBy: 'creately',
  },
  {
    id: 'database',
    name: 'Database',
    description: 'Data model',
    thumbnailUrl: '/assets/images/thumbnails/tb_database.svg',
    translationKey: 'templates.names.database',
    artifact: { kind: 'legacy', templateId: 'ijS6B7RhEZr', legacyType: 'diagram/def/database.js#Database' },
    job: ['design-system'],
    function: ['software'],
    curatedBy: 'creately',
  },
]
